import namely from '@/assets/integrations/Namely.png'
import hrwize from '@/assets/integrations/HRwize.png'
import zohoPeople from '@/assets/integrations/ZohoPeople.png'
import workable from '@/assets/integrations/Workable.png'
import netsuite from '@/assets/integrations/NetSuite.png'
import xero from '@/assets/integrations/Xero.png'
import zohoBooks from '@/assets/integrations/ZohoBooks.png'
import quickbooks from '@/assets/integrations/Quickbooks.png'
import kashoo from '@/assets/integrations/Kashoo.png'
import deputy from '@/assets/integrations/Deputy.png'
import humanity from '@/assets/integrations/Humanity.png'
import workflowMax from '@/assets/integrations/WorkflowMax.png'
import whenIWork from '@/assets/integrations/WhenIWork.png'
import toggl from '@/assets/integrations/Toggl.png'
import easyClocking from '@/assets/integrations/EasyClocking.png'
import quickbooksTime from '@/assets/integrations/QuickBooksTime.png'
import swipeClock from '@/assets/integrations/SwipeClock.png'
import sevenShifts from '@/assets/integrations/7shifts.png'
import zohoTimesheets from '@/assets/integrations/ZohoTimesheets.png'
import zohoShifts from '@/assets/integrations/ZohoShifts.png'
import taxSlips from '@/assets/integrations/TaxSlips.png'

export type Partner = {
  name: string
  logo: string
  website: string
  guide: string
  capabilities: string[]
}

export type Category = {
  name: string
  blurb: string
  partners: Partner[]
}

const GUIDE = 'https://www.simplepay.ca/canada_payroll/help/guides/index.php?name='

export const categories: Category[] = [
  {
    name: 'HR',
    blurb: 'Keep employee records in sync — no double entry.',
    partners: [
      {
        name: 'Namely',
        logo: namely,
        website: 'https://www.namely.com/',
        guide: `${GUIDE}namely`,
        capabilities: ['Import / export employees', 'Sync employee data'],
      },
      {
        name: 'HRwize',
        logo: hrwize,
        website: 'https://hrwize.com',
        guide: `${GUIDE}hrwize`,
        capabilities: ['Import / export employees', 'Sync employee data', 'Import timesheets'],
      },
      {
        name: 'Zoho People',
        logo: zohoPeople,
        website: 'https://www.zoho.com/people/',
        guide: `${GUIDE}zoho_people`,
        capabilities: ['Import employees', 'Import timesheets'],
      },
      {
        name: 'Workable',
        logo: workable,
        website: 'https://www.workable.com/',
        guide: `${GUIDE}workable`,
        capabilities: ['Import / export employees', 'Sync employee data'],
      },
    ],
  },
  {
    name: 'Accounting',
    blurb: 'Push payroll journals straight into your ledger.',
    partners: [
      {
        name: 'NetSuite',
        logo: netsuite,
        website: 'http://www.netsuite.com/portal/home.shtml',
        guide: `${GUIDE}netsuite`,
        capabilities: [
          'Payroll journal with multi-wage accounts',
          'Import / export employees and sync',
          'Single Sign-On (SSO)',
        ],
      },
      {
        name: 'Xero',
        logo: xero,
        website: 'http://www.xero.com/',
        guide: `${GUIDE}xero`,
        capabilities: ['Payroll journal with multi-wage accounts', 'Tracking categories'],
      },
      {
        name: 'Zoho Books',
        logo: zohoBooks,
        website: 'https://www.zoho.com/books/',
        guide: `${GUIDE}zohobooks`,
        capabilities: ['Export payroll journal'],
      },
      {
        name: 'QuickBooks',
        logo: quickbooks,
        website: 'https://quickbooks.intuit.com/ca/',
        guide: `${GUIDE}quickbooks`,
        capabilities: ['Payroll journal (desktop & online)', 'Import timesheets (+ scheduling)'],
      },
      {
        name: 'Kashoo',
        logo: kashoo,
        website: 'http://www.kashoo.com',
        guide: `${GUIDE}kashoo`,
        capabilities: ['Export payroll journal'],
      },
    ],
  },
  {
    name: 'Time, Attendance & Scheduling',
    blurb: 'Approved hours flow straight into the pay run.',
    partners: [
      {
        name: 'Deputy',
        logo: deputy,
        website: 'https://www.deputy.com/',
        guide: `${GUIDE}deputy`,
        capabilities: ['Import / export employees', 'Import timesheets (+ scheduling)'],
      },
      {
        name: 'Humanity',
        logo: humanity,
        website: 'https://www.humanity.com/',
        guide: `${GUIDE}humanity`,
        capabilities: ['Import / export employees', 'Import timesheets (+ scheduling)'],
      },
      {
        name: 'WorkflowMax',
        logo: workflowMax,
        website: 'http://www.workflowmax.com/',
        guide: `${GUIDE}workflowmax`,
        capabilities: ['Import / export employees', 'Import timesheets (+ scheduling)'],
      },
      {
        name: 'When I Work',
        logo: whenIWork,
        website: 'http://wheniwork.com/',
        guide: `${GUIDE}wheniwork`,
        capabilities: ['Import / export employees', 'Import timesheets (+ scheduling)'],
      },
      {
        name: 'Toggl',
        logo: toggl,
        website: 'https://www.toggl.com/',
        guide: `${GUIDE}toggl`,
        capabilities: ['Import / export employees', 'Import timesheets (+ scheduling)'],
      },
      {
        name: 'EasyClocking',
        logo: easyClocking,
        website: 'https://easyclocking.com/',
        guide: `${GUIDE}EasyWorkforce`,
        capabilities: ['Import / export employees', 'Import timesheets (+ scheduling)'],
      },
      {
        name: 'HRwize',
        logo: hrwize,
        website: 'https://hrwize.com/',
        guide: `${GUIDE}hrwize`,
        capabilities: ['Import / export employees and sync', 'Import timesheets'],
      },
      {
        name: 'QuickBooks Time',
        logo: quickbooksTime,
        website: 'https://quickbooks.intuit.com/ca/time-tracking/',
        guide: `${GUIDE}tsheets`,
        capabilities: ['Payroll journal (desktop & online)', 'Import timesheets (+ scheduling)'],
      },
      {
        name: 'SwipeClock',
        logo: swipeClock,
        website: 'https://www3.swipeclock.com/',
        guide: `${GUIDE}swipeclock`,
        capabilities: ['Import / export employees', 'Import timesheets (+ scheduling)'],
      },
      {
        name: '7shifts',
        logo: sevenShifts,
        website: 'https://www.7shifts.com/',
        guide: `${GUIDE}7shifts`,
        capabilities: ['Import / export employees', 'Import timesheets (+ scheduling)'],
      },
      {
        name: 'Zoho Timesheets',
        logo: zohoTimesheets,
        website: 'https://www.zoho.com/people/',
        guide: `${GUIDE}zoho_people`,
        capabilities: ['Import employees', 'Import timesheets'],
      },
      {
        name: 'Zoho Shifts',
        logo: zohoShifts,
        website: 'https://www.zoho.com/shifts/',
        guide: `${GUIDE}zoho_shifts`,
        capabilities: ['Import / export employees', 'Import timesheets (+ scheduling)'],
      },
    ],
  },
  {
    name: 'Year-End & Filing',
    blurb: 'Close the year without the spreadsheet gymnastics.',
    partners: [
      {
        name: 'TaxSlips',
        logo: taxSlips,
        website: 'https://www.taxslips.ca/',
        guide: `${GUIDE}year_end_filing`,
        capabilities: ['Export payroll year-to-date', 'T4 / RL-1 filing', 'PIER'],
      },
    ],
  },
]

export const partnerCount = categories.reduce((n, c) => n + c.partners.length, 0)
